module.exports = __webpack_public_path__ + "static/home-ourproduct-powerapps-de69daba4fa63fefc9d8fe909abb5a6f.png";